const cf7Registration = () => {
  document.addEventListener("DOMContentLoaded", () => {

    const popupWrapper   = document.getElementById('form-block-registration');
    const messageWrapper = document.getElementById('success-message-registration');

    if(!popupWrapper){
      return;
    }

    document.addEventListener( 'wpcf7mailsent', function( event ) {
      popupWrapper.style.display = 'none';
      messageWrapper.style.display = 'block';
    }, false );

  });
};

export default cf7Registration;



